<template>
	<div class="textStatus">
		<div class="status" v-if="tableData.statusSty" :style="[statusSty]">
			<ig-icon name="yuan"></ig-icon>
		</div>
		<div class="content" :style="[tableData.style, style]" @click="webskip">
			{{ content() }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		return {};
	},
	mounted() {},
	computed: {
		statusSty() {
			let val = this.scope.row[this.tableData.bind];
			return this.tableData.statusSty && this.tableData.statusSty(val, this.scope.row);
		},
		style() {
			let val = this.scope.row[this.tableData.bind];
			return this.tableData.style && this.tableData.style(val, this.scope.row);
		},
	},
	methods: {
		webskip() {
			let { scope, tableData } = this;
			tableData.webskip && tableData.webskip(scope.row[tableData.bind], scope.row);
		},
		content() {
			let val = this.scope.row[this.tableData.bind];
			return (
				(this.tableData.dataStyle && this.tableData.dataStyle(val, this.scope.row)) ||
				this.scope.row[this.tableData.bind]
			);
		},
	},
	components: {},
};
</script>

<style lang="scss" scoped>
.textStatus {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	.content {
		flex: 1;
	}
	.status {
		width: 20px;
		height: 20px;
		line-height: 20px;
		color: #999;
		.iconfont {
			font-size: 12px;
		}
	}
}
</style>
